/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RAMStat
 */
export interface RAMStat {
    /**
     * 
     * @type {number}
     * @memberof RAMStat
     */
    time: number;
    /**
     * 
     * @type {number}
     * @memberof RAMStat
     */
    cTotal: number;
    /**
     * 
     * @type {number}
     * @memberof RAMStat
     */
    cUsed: number;
    /**
     * 
     * @type {number}
     * @memberof RAMStat
     */
    cCached: number;
    /**
     * 
     * @type {number}
     * @memberof RAMStat
     */
    cBuffered: number;
}

export function RAMStatFromJSON(json: any): RAMStat {
    return RAMStatFromJSONTyped(json, false);
}

export function RAMStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): RAMStat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': json['time'],
        'cTotal': json['c_total'],
        'cUsed': json['c_used'],
        'cCached': json['c_cached'],
        'cBuffered': json['c_buffered'],
    };
}

export function RAMStatToJSON(value?: RAMStat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time,
        'c_total': value.cTotal,
        'c_used': value.cUsed,
        'c_cached': value.cCached,
        'c_buffered': value.cBuffered,
    };
}


